import { BasicTenant, Mutation } from 'graphql/generated/graphqlTypes';

export function mockedVerifyCognitoUserData(verifyAccount: BasicTenant): Pick<Mutation, 'verifyAccount'> {
  return {
    verifyAccount
  };
}

export const mockedVerifyCognitoUserDataForQuery = mockedVerifyCognitoUserData({
  __typename: 'BasicTenant',
  tenantId: 'mockedTenantId',
  name: 'mockedTenantName',
  onboardingStep: 'mockedCognitoOnboardingStep'
});
